export const skillsData = [
    {
    id: 'data',
    title: 'Data',
    items: ['Python', 'Pandas', 'NumPy', 'Scikit-learn', 'TensorFlow', 'PyTorch'],
  },
  {
    id: 'ai',
    title: 'AI',
    items: ['LangChain', 'Fine Tuning', 'OpenAI API', 'RAG', 'MCP', 'n8n'],
  },
  {
    id: 'frontend',
    title: 'Frontend',
    items: ['React', 'JavaScript', 'TypeScript', 'Tailwind CSS', 'Bootstrap', 'MUI'],
  },
  {
    id: 'backend',
    title: 'Backend',
    items: [ 'Django', 'FastAPI', 'Node.js', 'Docker', 'PostgreSQL', 'MySQL'],
  },
  // {
  //   id: 'pm',
  //   title: 'Project Management',
  //   items: ['Problem Solving', 'Bidding', 'Stakeholder Mgmt', 'Presentation', 'Priority Mgmt', 'Time Management'],
  // },
  // {
  //   id: 'ba',
  //   title: 'Business Analysis',
  //   items: ['Requirement Gathering', 'Process Improvement', 'Process Mapping', 'Data Analysis', 'Stakeholder Analysis', 'Change Management'],
  // },
  // {
  //   id: 'tools',
  //   title: 'Tools & Platforms',
  //   items: ['AWS', 'Azure', 'Docker', 'GitHub', 'Excel', 'Power BI', 'CI/CD', 'Jira'],
  // },
]
